<template>
  <validation-observer ref="updatePartnerConfig" #default="{ invalid }">
    <n-form-confirmation
      key="updatePartnerConfig"
      @submit="validateForm"
      :form="$refs.updatePartnerConfig"
      :disabled="invalid"
    >
      <n-input :fields="fields" v-model="data"> </n-input>
      <b-row>
        <b-col cols="12" class="text-right">
          <n-button-loading
            type="submit"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1"
            :loading="loading"
            :disabled="invalid"
          >
            {{ $t("button.saveChanges") }}
          </n-button-loading>
        </b-col>
      </b-row>
    </n-form-confirmation>
  </validation-observer>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardText,
  BLink,
  BRow,
  BCol,
  BButton,
  BAvatar,
  BAlert,
  BFormGroup,
  BFormRating,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import NButtonLoading from "@/components/NButtonLoading";
import NFormConfirmation from "@/components/NFormConfirmation";
import NInput from "@/components/NInput";
import FormInput from "./updatePartnerConfig";
import { mapValidationMessage } from "@/libs/helper";
import NSingleImageUploader from "@/components/NSingleImageUploader";
import Repository from "@/repositories/RepositoryFactory";
const IntegrationRepository = Repository.get("integration");

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BCardText,
    BLink,
    BButton,
    BAvatar,
    BAlert,
    BFormGroup,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    NSingleImageUploader,
    BFormRating,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    validateForm() {
      this.$refs.updatePartnerConfig.validate().then((success) => {
        if (success) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;
      IntegrationRepository.updateConfigPartner({
        ...this.data,
      })
        .catch((error) => {
          console.log(error.response);
          if (error.response?.status === 422) {
            const errorMessage = mapValidationMessage(
              error.response.data.validate
            );
            this.$refs.updatePartnerConfig.setErrors(errorMessage);
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  setup() {
    const fields = FormInput;
    return {
      fields,
    };
  },
};
</script>
